//@ts-check

const { ENV_VAR_NAME_COOKIE, SESSION_VAR_NAME_COOKIE } = require('../constants.es');

const ENV_VAR_NAME = ENV_VAR_NAME_COOKIE;
const SESSION_VAR_NAME = SESSION_VAR_NAME_COOKIE;

const BannerClassName = exports.BannerClassName = 'GDPR_CookieBanner';

const BannerSelector = '#gdpr-cookie-accept';

/** @param {Fox} fox */
exports.factory = (fox) => {
	//@ts-ignore
	const { delay } = require('common-stuffs/utils')(fox);

	const $ = fox.jQuery;	
	
	fox.registerWidget(BannerClassName, {
		configure() {
			this.registerOptions('', {
				autoRender: true,
				embed: {
					container: '#notification-container'
				},
				template: 'gdpr_cookie_banner',
				showBannerPredicat: () => {
					if (fox.site.getClass() === "FanApp") return false;
					const sessionFlag = localStorage.getItem(SESSION_VAR_NAME);
					
					if (!this.userAccess) {
						return !sessionFlag;
					}

					return !fox.getEnv(`${ENV_VAR_NAME}.cookiesStrict`);
				},
				handleDom: {
					accept: {
						target: '#accept-cookies',
						callback: () => this.acceptCookies()
					},
					scroll: {
						event: 'scroll',
						target: document,
						eventChecker: _ => this.isEmbedded(),
						callback: () => {
							const bar = $(fox.dom.selectFirst(BannerSelector));
							const barHeight = bar.height();
							const scrollTop = $(window).scrollTop();

							if (scrollTop > 30) {
								bar.css('top', this._getBannerYPos(false) - 2);
								bar.addClass('sticky')
							} else {
								bar.css('top', '0');
								bar.removeClass('sticky');
							}
						}
					}
				},
				handleWom: {
					onLayoutChanged: {
						event: 'addedToDom',
						widget: '@root .Site_Layout',
						callback: () => !this.isEmbedded() && this.render()
					},
				}
			});
			this.callParent('configure', arguments);
		},

		init() {
			this.showBannerPredicat = this.requireOption('showBannerPredicat');
			this.userAccess = this.wom1('@root #permissionManager') ? !this.rwom1('@root #permissionManager').hasAccess('guestActual') : fox.isObject(fox.site.member);
		},

		activate(){
			if (this.showBannerPredicat()) {
				return delay(2000).then(() => this.callParent('activate', arguments));
			}
		},

		prepareEmbeddedWidgets() {
			this._bindData = {
				position: '-300%'
			};

			this.bindTemplateVariables(this._bindData, [
				'position'
			]);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},

		_getBannerYPos(skipNodes = true) {
			const anotherBanners = fox.dom.select('.strip-notification-wrapper');
			const myNode = fox.dom.selectFirst(BannerSelector);

			if (anotherBanners.length > 1) {
				return anotherBanners.reduce((acc, bannerNode) => {
					if (bannerNode === myNode)
						return acc;

					return acc + (skipNodes ? 0 : bannerNode.clientHeight);
				}, 2);
			}

			return 0;
		},

		addedToDom() {
			this.callParent('addedToDom', arguments);

			delay(100).then(() => {
				this._bindData.position = `${this._getBannerYPos()}px`;
			});
		},

		acceptCookies() {
			const api = this.getApi('_cookieConsent', {
				method: 'consent.provideBulk',
				httpMethod: 'post'
			});

			this.closeBanner();

			if (this.userAccess) {
				api.psend({
					aliases: {
						cookiesFunctional: 1,
						cookiesPerformance: 1,
						cookiesStrict: 1
					}
				});
			} else {
				localStorage.setItem(SESSION_VAR_NAME, new Date().getTime().toString());
			}
		},

		closeBanner() {
			this._bindData.position = '-300%';
			this.removeFromDom();
		},

		beforeEmbed() {
			if (this.showBannerPredicat()) {
				return delay(2000).then(() => this.callParent('beforeEmbed', arguments));
			}
		},



		removeFromDom() {
			delay(410).then(() => {
				const myNode = fox.dom.selectFirst(BannerSelector);

				if (myNode) {
					myNode.parentNode.removeChild(myNode);
				}
			});
		},

		embedToDom(container) {
			if (!this.isEmbedded()) {
				container.appendChild(this.fragment);
			}
		},

		isEmbedded() {
			return !fox.isEmpty(fox.dom.selectFirst(BannerSelector));
		}
	})
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/GDPR-popups/widget/CookieBanner.es.js